
        import * as module0 from './controllers/app_preview_controller.js';import * as module1 from './controllers/example_controller.js';import * as module2 from './controllers/navigation_controller.js';import * as module3 from './controllers/page_height_controller.js'
        const modules = {
            "./controllers/app_preview_controller.js": module0,
            "./controllers/example_controller.js": module1,
            "./controllers/navigation_controller.js": module2,
            "./controllers/page_height_controller.js": module3,
        };
        export default modules;
      